module.exports = __webpack_public_path__ + "static/media/email.a432def0.svg";